window.addEventListener('DOMContentLoaded', event => {

	const breakpointLengthForAjaxRequest = 1;
	const searchInputs = document.getElementsByClassName('search-field');

	let isSelecting = false;

	const removeDropdown = (event) => {
		const searchWrapper = event.target.parentElement.querySelectorAll('.search-field-result-wrapper');
		if (searchWrapper.length) {
			[...searchWrapper].forEach((el) => el.remove());
		}
	}

	const onClickValue = (valueObject, inputName) => {
		// console.log('[onClickValue] Setting value for', inputName, 'to', valueObject);
		const inputFields = document.getElementsByClassName('search-field');
		[...inputFields].forEach((el) => {
			if (el.name === inputName && el.type === 'text') {
				el.value = valueObject.value;
			}
			if (el.name === `${inputName}id` && el.type === 'hidden') {
				el.value = valueObject.id;
				//console.log('[onClickValue] Hidden field', el.name, 'now =', el.value);
			}
		})
	}

	const resetHiddenInput = (inputName) => {
		const inputFields = document.getElementsByClassName('search-field');
		[...inputFields].forEach((el) => {
			if (el.name === `${inputName}id` && el.type === 'hidden') {
				el.value = '';
			}
		})
	}

	const onInput = async (event, valueChanged = false) => {
		//console.log('[onInput]', event.type, 'valueChanged:', valueChanged, 'current value:', event.target.value);
		removeDropdown(event);
		if (valueChanged) {
			resetHiddenInput(event.target.name);
			//console.log('[onInput] Hidden field reset for', event.target.name);
		}

		if (event.target.value.length > breakpointLengthForAjaxRequest) {
			const { origin } = window.location
			const url = `${origin}/include/ajax/${event.target.dataset.ajaxFile || event.target.name}.php?search=${event.target.value}`;
			//console.log('[onInput] Fetching:', url);
			try {
				const response = await fetch(url);
				if (!response.ok) {
					throw new Error(`Response status: ${response.status}`);
				}
				const json = await response.json();
				//console.log('[onInput] Results received:', json.result.length);

				if (json.result.length > 0) {
					// Create results.
					const resultsDivEl = document.createElement('div');
					resultsDivEl.className = 'search-field-result-wrapper shadow-sm';
					const resultsUlEl = document.createElement('ul');
					for (let i = 0; i < json.result.length; i++) {
						const resultsLiEl = document.createElement('li');
						resultsLiEl.innerText = json.result[i].value;
						//resultsLiEl.addEventListener('click', () => onClickValue(json.result[i], event.target.name));

						// Test for fixing issues on Mac
						resultsLiEl.addEventListener('pointerdown', (e) => {
							e.preventDefault();
							e.stopPropagation();
							isSelecting = true;
							onClickValue(json.result[i], event.target.name);
							// Close the dropdown right away to avoid stray clicks
							resultsDivEl.remove();
							// allow focusout to run after we’ve set the value
							setTimeout(() => { isSelecting = false; }, 0);
						});

						// Fallback for older browsers (optional)
						resultsLiEl.addEventListener('mousedown', (e) => {
							if (e.pointerType) return; // pointerdown already handled
							e.preventDefault();
							e.stopPropagation();
							isSelecting = true;
							onClickValue(json.result[i], event.target.name);
							resultsDivEl.remove();
							setTimeout(() => { isSelecting = false; }, 0);
						});

						resultsUlEl.appendChild(resultsLiEl);
					}
					resultsDivEl.appendChild(resultsUlEl);
					event.target.parentElement.appendChild(resultsDivEl);
				} else {
					// Create add new button if text exists, should also have a modal in the html.
					if (event.target?.dataset?.textAddNew) {
						const resultsDivEl = document.createElement('div');
						resultsDivEl.className = 'search-field-result-wrapper shadow-sm';
						const resultsUlEl = document.createElement('ul');
						const addNewLiEl = document.createElement('li');
						addNewLiEl.className = 'is-bold';
						addNewLiEl.innerText = event.target.dataset.textAddNew;
						addNewLiEl.setAttribute('data-bs-toggle', 'modal');
						addNewLiEl.setAttribute('data-bs-target', `#${event.target.name}-modal`);
						resultsUlEl.appendChild(addNewLiEl);
						resultsDivEl.appendChild(resultsUlEl);
						event.target.parentElement.appendChild(resultsDivEl);
					} else if (event.target?.dataset?.textNoResults) {
						// Display text if no results are found and text is included.
						const resultsDivEl = document.createElement('div');
						resultsDivEl.className = 'search-field-result-wrapper shadow-sm';
						const resultsUlEl = document.createElement('ul');
						const addNewLiEl = document.createElement('li');
						addNewLiEl.innerText = event.target.dataset.textNoResults;
						addNewLiEl.classList.add('not-clickable');
						resultsUlEl.appendChild(addNewLiEl);
						resultsDivEl.appendChild(resultsUlEl);
						event.target.parentElement.appendChild(resultsDivEl);
					}
				}
			} catch (error) {
				console.error(error.message);
			}
		}
	}

	const onFocusOut = (event) => {
		//console.log('[onFocusOut]', event.target.name, 'required:', event.target.required);
		if (isSelecting) return; // don't validate mid-pick

		event.target.classList.remove('is-invalid');
		event.target.classList.remove('is-valid');

		setTimeout(() => {
			removeDropdown(event);
			if (event.target.required) {
				const inputFields = document.getElementsByClassName('search-field');
				[...inputFields].forEach((el) => {
					if (el.name === `${event.target.name}id` && el.type === 'hidden') {
						//console.log('[onFocusOut] Hidden field', el.name, '=', el.value);
						if (el.value)
							event.target.classList.add('is-valid');
						else
							event.target.classList.add('is-invalid');
					}
				});
			} else {
				event.target.classList.add('is-valid');
			}
		}, 150);
	}

	if (searchInputs.length > 0) {
		[...searchInputs].forEach((el) => {
			if (el?.type === 'text') {
				// Add event listeners to the input element.
				el.addEventListener("input", (event) => onInput(event, true));
				el.addEventListener("focusin", onInput);
				el.addEventListener("focusout", onFocusOut);
			}
		})
	}

});
